import React from 'react';

import lessRequire from '../../../config/less-require-resolver';

import withIntl from '../intl-hoc';

lessRequire('modules/shared/table/show-more-rows.less');

function ShowMoreRows({ intl, showMore }) {
	return (
		<div className="show-more-rows">
			<div
				className="show-more-rows-icon font-proxima-nova-regular"
				onClick={showMore}
			>
				{intl('Показать ещё')}
			</div>
		</div>
	);
}

export default withIntl(ShowMoreRows);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/table/show-more-rows.js